// @flow
import {call, select} from 'redux-saga/effects';
import {StackActions} from '@react-navigation/native';
import type {SignUpActionType} from '../actions';
import {
  hasBillingAddressSelector,
  hasCustomerIdentificationSelector,
} from '../../Customer/selectors';
import Navigation, {navigate} from '../../../lib/navigation';
import {eSimSelectedSelector} from '../../../modules/ESim';
import { hasCustomPaymentMeanSelector } from '../../Customer/selectors';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* goToNextOrderPage(
  action: SignUpActionType,
  replaceRoute: boolean = false,
): Generator<*, *, *> {
  if (action.type !== 'SIGNUP_GO_TO_NEXT_ORDER_PAGE') {
    return;
  }

  const eSimSelected = yield select(eSimSelectedSelector);
  WizzeeLog.log('>>> goToNextOrderPage eSimSelected: ', eSimSelected);
  WizzeeLog.log('>>> goToNextOrderPage action.payload: ', action.payload);
  const goTo = routeName => {
    if (replaceRoute) {
      WizzeeLog.log('>>> goTo::replace route -> ', routeName);
      return call(Navigation.dispatch, StackActions.replace(routeName));
    }
    WizzeeLog.log('>>> goTo::navigate -> ', routeName);
    return call(navigate, routeName);
  };

  if (action.payload.routeName) {
    return yield goTo(action.payload.routeName);
  }

  const hasCustomerIdentification = yield select(
    hasCustomerIdentificationSelector,
  );
  if (!hasCustomerIdentification) {
    return yield goTo('identityRequirements');
  }

  const hasBillingAddress = yield select(hasBillingAddressSelector);
  if (!hasBillingAddress) {
    return yield goTo('billingAddress');
  }

  if (eSimSelected) {
    const hasPaymentMean = yield select(hasCustomPaymentMeanSelector);
    WizzeeLog.log('>>> hasPaymentMean: ', hasPaymentMean);
    return yield goTo(
      hasPaymentMean ? 'confirmPlanDuringActivate' : 'registerPaymentDetails',
    );
  }

  return yield goTo('deliveryAddress');
}
